import script from "./CampaignTypesForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CampaignTypesForm.vue?vue&type=script&setup=true&lang=js"

import "./CampaignTypesForm.vue?vue&type=style&index=0&id=77a40db6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77a40db6"]])

export default __exports__